import { render } from "./UpgradePlan.vue?vue&type=template&id=6c8f7254"
import script from "./UpgradePlan.vue?vue&type=script&lang=js"
export * from "./UpgradePlan.vue?vue&type=script&lang=js"

import "./UpgradePlan.vue?vue&type=style&index=0&id=6c8f7254&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__